(() => {
  const intent = (value) => {
    let terms = value.trim();
    let min = '', max = '';
    const between = terms.match(/(?:between\s*)?\$?([\d,]+(?:\.\d{1,2})?)\s*(?:-|to|and)\s*\$?([\d,]+(?:\.\d{1,2})?)/i);
    const under = terms.match(/(?:under|below|up to|less than)\s*\$?([\d,]+(?:\.\d{1,2})?)/i);
    if (between && (/between|\$/.test(between[0]))) {
      min = Number(between[1].replaceAll(',', ''));
      max = Number(between[2].replaceAll(',', ''));
      if (min > max) [min, max] = [max, min];
      terms = terms.replace(between[0], ' ');
    } else if (under) {
      max = Number(under[1].replaceAll(',', ''));
      terms = terms.replace(under[0], ' ');
    }
    terms = terms.replace(/\b(?:bc|british columbia|alaska|yukon)\b/gi, 'Alaskan')
      .replace(/\b(?:aussie|australia)\b/gi, 'Australian')
      .replace(/\bjewellery\b/gi, 'jewelry')
      .replace(/\bgold\s+(?:and|with)\s+quartz\b/gi, 'gold quartz')
      .replace(/\s+/g, ' ').trim();
    return { terms: terms || 'gold', min, max };
  };
  const searchUrl = (action, parsed) => {
    const url = new URL(action, location.origin);
    url.searchParams.set('q', parsed.terms);
    url.searchParams.set('type', 'product');
    url.searchParams.set('filter.v.availability', '1');
    if (parsed.min !== '') url.searchParams.set('filter.v.price.gte', parsed.min);
    if (parsed.max !== '') url.searchParams.set('filter.v.price.lte', parsed.max);
    return url;
  };
  const score = (current, candidate) => {
    if (current.family !== candidate.family || current.id === candidate.id) return -1;
    if (current.family === 'other' && (!current.kind || current.kind !== candidate.kind)) return -1;
    if (current.family === 'nugget' && current.kind !== 'natural' && current.kind !== candidate.kind) return -1;
    if (current.family === 'jewelry' && current.kind !== candidate.kind) return -1;
    let result = current.kind === candidate.kind ? 60 : 0;
    if (current.origin && current.origin === candidate.origin) result += 25;
    if (current.family === 'nugget' && current.weight > 0 && candidate.weight > 0) {
      const ratio = Math.min(current.weight, candidate.weight) / Math.max(current.weight, candidate.weight);
      result += ratio * 25;
    }
    if (current.price > 0 && candidate.price > 0) result += Math.min(current.price, candidate.price) / Math.max(current.price, candidate.price) * 20;
    return result >= 50 ? result : -1;
  };
  window.NbgShopping = { intent, searchUrl, score };
  const currentParams = new URL(window.location.href).searchParams;
  document.querySelectorAll('[data-nbg-recovery-link]').forEach((link) => {
    const url = new URL(link.getAttribute('href'), location.origin);
    for (const name of ['filter.v.price.gte', 'filter.v.price.lte']) {
      const value = currentParams.get(name);
      if (value !== null && /^\d+(?:\.\d+)?$/.test(value)) url.searchParams.set(name, value);
    }
    link.href = url.toString();
  });

  if (!customElements.get('nbg-product-matches')) {
    customElements.define('nbg-product-matches', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.current = JSON.parse(this.dataset.profile);
        this.cards = new Map();
        this.add(this.querySelector('template').content);
        this.paint();
        if (!this.current.available) { this.load(); } else if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
          }, { rootMargin: '500px' });
          this.observer.observe(this);
        } else this.load();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
      add(root) {
        root.querySelectorAll('[data-nbg-profile]').forEach((card) => {
          try {
            const profile = JSON.parse(card.dataset.nbgProfile);
            if (profile.available && profile.id !== this.current.id && !this.cards.has(profile.id)) this.cards.set(profile.id, { profile, card });
          } catch {}
        });
      }
      paint() {
        const ranked = [...this.cards.values()].map((item) => ({ ...item, rank: score(this.current, item.profile) }))
          .filter((item) => item.rank >= 0).sort((a, b) => b.rank - a.rank || a.profile.price - b.profile.price);
        const similar = ranked.slice(0, 4);
        this.matchesCount = similar.length;
        const less = ranked.filter((item) => item.profile.price < this.current.price && item.profile.price >= this.current.price * 0.3 && !similar.includes(item)).slice(0, 3);
        const draw = (target, items) => {
          if (!target) return;
          target.replaceChildren(...items.map((item) => item.card.cloneNode(true)));
        };
        draw(this.querySelector('[data-match-grid]'), similar);
        this.querySelector('[data-match-row]').hidden = similar.length === 0;
        draw(this.querySelector('[data-less-grid]'), less);
        this.querySelector('[data-less-row]').hidden = less.length === 0;
        draw(document.querySelector('[data-nbg-sold-target]'), similar);
      }
      async load() {
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 8000);
        try {
          const response = await fetch(this.dataset.url, { signal: this.controller.signal, credentials: 'same-origin' });
          if (!response.ok) return;
          this.add(new DOMParser().parseFromString(await response.text(), 'text/html'));
          if (this.isConnected) this.paint();
        } catch {} finally {
          clearTimeout(timeout);
          if (this.isConnected && this.matchesCount < 4 && this.dataset.fallbackUrl) {
            try {
              const response = await fetch(this.dataset.fallbackUrl, { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
              if (!response.ok || !this.isConnected) return;
              this.add(new DOMParser().parseFromString(await response.text(), 'text/html'));
              this.paint();
            } catch {}
          }
        }
      }
    });
  }

  if (!customElements.get('nbg-top-ten')) {
    customElements.define('nbg-top-ten', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.track = this.querySelector('ul');
        this.buttons = [...this.querySelectorAll('button[data-step]')];
        this.buttons.forEach((button) => button.addEventListener('click', () => {
          this.track.scrollBy({ left: Number(button.dataset.step) * this.track.clientWidth * 0.85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }));
        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
        this.resize = new ResizeObserver(() => this.updateControls());
        this.resize.observe(this.track);
        this.load();
      }
      disconnectedCallback() { this.controller?.abort(); this.resize?.disconnect(); }
      updateControls() {
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
      async load() {
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 8000);
        const status = this.querySelector('[role="status"]');
        try {
          const sources = JSON.parse(this.querySelector('[data-pick-sources]').textContent);
          const pools = await Promise.allSettled(sources.map(async (source, sourceIndex) => {
            const url = new URL(source.url, location.origin);
            url.searchParams.set('filter.v.availability', '1');
            url.searchParams.set('sort_by', 'best-selling');
            url.searchParams.set('section_id', 'nbg-choice-cards');
            const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
            if (!response.ok) return [];
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            return [...html.querySelectorAll('[data-nbg-profile]')].flatMap((card, index) => {
              try {
                const profile = JSON.parse(card.dataset.nbgProfile);
                if (!profile.available || !['nugget', 'jewelry'].includes(profile.family)) return [];
                const band = profile.price < 20000 ? 0 : profile.price < 50000 ? 1 : profile.price < 100000 ? 2 : profile.price < 250000 ? 3 : 4;
                return [{ card, profile, band, sourceIndex, rank: source.weight + 24 - index }];
              } catch { return []; }
            });
          }));
          const candidates = new Map();
          const groups = pools.map((pool) => pool.status === 'fulfilled' ? pool.value : []);
          for (const group of groups) for (const item of group) {
            const prior = candidates.get(item.profile.id);
            if (!prior || item.rank > prior.rank) candidates.set(item.profile.id, item);
          }
          const selected = [], seen = new Set(), kinds = new Map(), bands = new Map(), origins = new Map();
          const add = (item) => {
            selected.push(item); seen.add(item.profile.id);
            const kind = item.profile.family + ':' + item.profile.kind;
            kinds.set(kind, (kinds.get(kind) || 0) + 1);
            bands.set(item.band, (bands.get(item.band) || 0) + 1);
            origins.set(item.profile.origin, (origins.get(item.profile.origin) || 0) + 1);
          };
          const merit = (item) => item.rank
            + (bands.has(item.band) ? 0 : 28)
            + (origins.has(item.profile.origin) ? 0 : 12)
            - (kinds.get(item.profile.family + ':' + item.profile.kind) || 0) * 14
            - (bands.get(item.band) || 0) * 8;
          for (const group of groups) {
            const item = group.filter((entry) => !seen.has(entry.profile.id))
              .sort((a, b) => merit(b) - merit(a))[0];
            if (item && selected.length < 10) add(item);
          }
          while (selected.length < 10) {
            const item = [...candidates.values()].filter((entry) => !seen.has(entry.profile.id))
              .sort((a, b) => merit(b) - merit(a))[0];
            if (!item) break;
            add(item);
          }
          const cards = selected.map((item) => item.card);
          if (!this.isConnected) return;
          this.track.replaceChildren(...cards.map((card) => {
            const item = document.createElement('li');
            item.append(card);
            return item;
          }));
          status.textContent = cards.length ? '' : this.dataset.error;
          this.updateControls();
        } catch { if (this.isConnected) status.textContent = this.dataset.error; }
        finally { clearTimeout(timeout); this.track.removeAttribute('aria-busy'); }
      }
    });
  }
})();
